import { AccordionTableColumn } from "../types";
import { Dispatch, UnknownAction } from "redux";
import {
  openOperationModal,
  updateOperationData,
} from "../../../../../store/slices/operationDataSlice";

export const getColumnTextAlignment = <T,>(
  column?: AccordionTableColumn<T>,
) => {
  const map: {
    [key in AccordionTableColumn<T>["align"]]: AlignSetting;
  } = {
    start: "left",
    center: "center",
    end: "right",
  };

  return map[column?.align ?? "start"];
};

// UTILITY FUNCTIONS
export const createPriceClickHandler = (
  accountNumber: string | undefined,
  symbol: string,
  symbolType: string,
  side: "BUY" | "SELL",
  dispatch: Dispatch<UnknownAction>,
  liquidation?: string,
) => {
  return (price: number) => {
    const baseData = {
      account: accountNumber,
      symbol: symbol,
      symbolType: symbolType,
      orderType: "limited",
      side: side,
      ...(liquidation ? { liquidation: liquidation } : {}),
    };

    const operationData =
      symbolType === "REPO_OPERATION"
        ? { ...baseData, limitRate: String(price).replace(".", ",") }
        : { ...baseData, price: String(price) };

    dispatch(updateOperationData(operationData));
    dispatch(openOperationModal());
  };
};

const favoritesChangeEvent = new EventTarget();

export const emitFavoritesChange = () => {
  favoritesChangeEvent.dispatchEvent(new Event("favoritesChanged"));
};

export const onFavoritesChange = (callback: () => void) => {
  favoritesChangeEvent.addEventListener("favoritesChanged", callback);
  return () =>
    favoritesChangeEvent.removeEventListener("favoritesChanged", callback);
};

export const ALLARIA_LENDAR = "Allaria Lendar FCICC";
